export const NEW_PASSWORD_METHOD = {
  SMS: 'sms',
  EMAIL: 'email',
};

export const TIME_TO_RESEND_OTP = 120;
